import { render } from "./ImmunogeneticsReport.vue?vue&type=template&id=b2701166"
import script from "./ImmunogeneticsReport.vue?vue&type=script&lang=js"
export * from "./ImmunogeneticsReport.vue?vue&type=script&lang=js"

import "./ImmunogeneticsReport.vue?vue&type=style&index=0&id=b2701166&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__